<script>

import PageProfileVertical from "../../components/pages/page-profile-vertical";
import PageProfile from "@/components/pages/page-profile";
import PageForm from "@/components/pages/page-form";

export default {
  components: {
    PageProfileVertical,
    PageProfile,
    PageForm,
  },
  props: {
    pages: {
      required: true,
    },
    canEdit: {
      type: Boolean,
      required: true,
    },
    filter: {
      type: String
    }
  },
  data() {
    return {
      modalTitle: '',
      showModal: false,
      displayDetails: false,
      displayEditForm: false,
    };
  },
  methods: {
    formatDate(item) {
      let date = '';

      if (item.DateJour !== '' && item.DateJour !== ' ')
        date += item.DateJour;
      if (item.DateMois !== '' && item.DateMois !== ' ')
        date += (date !== '' ? '/' : '') + item.DateMois;
      if (item.DateAnnee !== '' && item.DateAnnee !== ' ')
        date += (date !== '' ? '/' : '') + item.DateAnnee;

      return date;
    },
    formatAdresse(item) {
      let adresse = '';

      if (item.Adresse !== '' && item.Adresse !== ' ')
        adresse += item.Adresse;
      if (item.Ville !== '' && item.Ville !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + item.Ville;
      if (item.Region !== '' && item.Region !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + item.Region;
      if (item.Pays !== '' && item.Pays !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + item.Pays;

      return adresse;
    },
    showPageDetails(page) {
      this.displayDetails = true;
      this.displayEditForm = false;
      this.selectedPage = page;
      this.modalTitle = page.NumPageAlbum;
    },
    showPageEditForm(page) {
      this.displayDetails = false;
      this.displayEditForm = true;
      this.selectedPage = page;
      this.modalTitle = '[EDIT]' + page.NumPageAlbum;
    },
    hideModal() {
      this.displayDetails = false;
      this.displayEditForm = false;
      this.selectedPage = null;
      this.modalTitle = '';

      this.$bvModal.hide('modal-page-details');
    },

    // Tout ça juste pour trier correctement un album sélectionné en mode Tous et Vignettes... Avec du temps, il
    // faudrait juste revoir la page et passer uniquement avec de la pagination côté API, cette fonction est terrible
    // et reproduit seulement du travail déjà fait en API, mais sinon ça prendrait une journée à reprendre le code
    // existant
    /*sort(v) {
      let temp = [];
      let temp2 = {};

      // On aplatit l'array d'object actuel
      for (const x of v) {
        for (const y in x) {
          if (!x[y]) {
            continue;
          }

          temp.push(x[y]);
        }
      }

      // On trie à nouveau pour que les pages exclus soient incluses
      temp.sort((a, b) => {
        a = a.NumPageAlbum;
        b = b.NumPageAlbum;

        if (a < b) {
          return -1;
        }

        if (a > b) {
          return 1;
        }

        return 0;
      });

      // On regroupe à nouveau
      for (const model of temp) {
        const v = model.NumPageAlbum;

        const verso = v[4] === 'V';
        const split = v.split(verso ? 'V' : 'R');

        if (!temp2[split[0]]) {
          temp2[split[0]] = {};
        }

        temp2[split[0]][verso ? 'verso' : 'recto'] = model;
      }

      return temp2;
    }*/

    sort(v) {
      return v;
    }
  }
};
</script>

<template>
  <div>
    <div class="row" v-for="(page, index) in sort(pages)" :key="index">
      <div class="col-sm-6">
        <div class="card p-1 border shadow-none" v-if="page.verso">
          <page-profile-vertical :page="page.verso" :with-commentaire="false"
                                 :with-inscription="false"></page-profile-vertical>

          <ul class="list-inline font-size-20 contact-links mb-0 text-right">
            <li class="list-inline-item px-2 text-info">
              <a v-b-modal.modal-page-details @click="showPageDetails(page.verso)"
                 title="Show">
                <i class="bx bx-show"></i>
              </a>
            </li>
            <li v-if="canEdit" class="list-inline-item px-2 text-warning">
              <a v-b-modal.modal-page-details @click="showPageEditForm(page.verso)"
                 title="Modify">
                <i class="bx bx-pencil"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="card p-1 border shadow-none" v-if="page.recto">
          <page-profile-vertical :page="page.recto" :with-commentaire="false"
                                 :with-inscription="false"></page-profile-vertical>

          <ul class="list-inline font-size-20 contact-links mb-0 text-right">
            <li class="list-inline-item px-2 text-info">
              <a v-b-modal.modal-page-details @click="showPageDetails(page.recto)"
                 title="Show">
                <i class="bx bx-show"></i>
              </a>
            </li>
            <li v-if="canEdit" class="list-inline-item px-2 text-warning">
              <a v-b-modal.modal-page-details @click="showPageEditForm(page.recto)"
                 title="Modify">
                <i class="bx bx-pencil"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <b-modal id="modal-page-details" :title="this.modalTitle" centered hide-footer
             size="xl"
             title-class="font-18"
             @hide="hideModal">
      <page-profile v-if="displayDetails" :page="this.selectedPage"></page-profile>

      <template v-if="canEdit">
        <page-form v-if="displayEditForm" :page="this.selectedPage" v-on:cancel="hideModal"
                   v-on:submitted="hideModal"></page-form>
      </template>
    </b-modal>
  </div>
</template>
